define('layout/version-warning',['jquery', 'jquery.cookie'], function ($) {
  'use strict';

  var versionWarning = $('.version-warning');
  function hideWarning(slide) {
    var callback = function callback() {
      document.documentElement.className += ' no-version-warning';
      versionWarning.trigger('hiding.versionwarning');
    };
    if (!slide) {
      versionWarning.hide();
      callback();
    } else {
      versionWarning.slideUp('slow', function () {
        versionWarning.slideUp('slow', callback);
      });
    }
  }
  return {
    init: function init() {
      if ($.cookie('versionWarning')) {
        hideWarning(false);
        return;
      }
      versionWarning.find('.close-trigger').on('click', function () {
        $.cookie('versionWarning', true, {
          path: '/'
        });
        hideWarning(true);
      });
    }
  };
});
